import * as SeparatorPrimitive from "@radix-ui/react-separator";

import styles from "./Separator.module.scss";

import { cn } from "@/utils/cn";

type BaseProps = React.ComponentProps<typeof SeparatorPrimitive.Separator>;

enum SeparatorWeight {
  Normal = "normal",
  Medium = "medium",
  SemiBold = "semiBold",
  Bold = "bold",
}

enum SeparatorVariant {
  Secondary = "secondary",
  Primary = "primary",
}

interface Props extends BaseProps {
  isVertical?: boolean;
  lineClassname?: string;
  weight?: SeparatorWeight;
  variant?: SeparatorVariant;
  horizontalSpacing?: number;
  verticalSpacing?: number;
}

const Separator: React.FC<Props> = ({
  isVertical = false,
  className,
  lineClassname,
  verticalSpacing,
  horizontalSpacing,
  weight = SeparatorWeight.Normal,
  variant = SeparatorVariant.Secondary,
  style,
}) => (
  <SeparatorPrimitive.Separator
    orientation={isVertical ? "vertical" : "horizontal"}
    style={{
      paddingInline: horizontalSpacing,
      paddingBlock: verticalSpacing,
      ...style,
    }}
    className={cn(styles.base, styles[weight], className)}
  >
    <div className={cn(styles.line, styles[variant], lineClassname)} />
  </SeparatorPrimitive.Separator>
);

export { Separator, SeparatorWeight, SeparatorVariant };
